import { call, takeEvery, put, select } from 'redux-saga/effects'
import { push } from 'react-router-redux'
import api from '../middleware/api'
import { gCall, is_ok } from './utils'
import * as route from '../routes'
import * as action from '../actions'

function* missionAnswered(act) {
  yield put(action.processMissionAnswered(act.payload))
  const answer = yield select(
    state => state.missions.answerMission.answer,
  )
  const user = yield select(
    state => state.user,
  )
  const response = yield call(api.finishMission, answer)
  if (is_ok(response.data)) {
    yield put(action.missionAnsweredSucceeded({ ...response.data, user }))
    yield put(action.loadUserProfile({ id: user.id }))
    const campaign = yield select(state => state.campaigns.selectedCampaign)
    yield put(push(route.mission_finished_path(campaign, response.data.mission)))
  } else {
    yield put(action.missionAnsweredFailed(response.data))
  }
}

function* watchForPreSelectMission() {
  yield takeEvery(action.MISSION_PRE_SELECT_FETCH, function* x({ payload }) {
    yield call(
      gCall(api.preSelectMission,
        action.missionPreSelectSucceeded,
        action.missionPreSelectFailed),
      { payload },
    )
    yield call(
      gCall(api.missionHistory,
      action.missionHistorySucceeded,
      action.missionHistoryFailed),
      { payload },
    )
  })
}

function* watchForMissionAnswered() {
  yield takeEvery(action.MISSION_ANSWER_DONE, missionAnswered)
}

function* watchForAcceptMission() {
  yield takeEvery(action.MISSION_ACCEPT_FETCH, function* x({ payload }) {
    const response = yield call(api.acceptMission, payload)
    if (is_ok(response.data)) {
      yield put(action.acceptMissionSucceeded(response.data, payload))
      const campaign = yield select(state => state.campaigns.selectedCampaign)
      yield put(push(route.mission_path(campaign, payload)))
    } else {
      yield put(action.acceptMissionFailed(response.data, payload))
    }
  })
}

function* watchForReviewMission() {
  // payload:{ missionId, answerId }
  yield takeEvery(action.MISSION_REVIEW_FETCH, function* x({ payload }) {
    const response = yield call(api.reviewMission, payload)
    if (is_ok(response.data)) {
      const campaign = yield select(state => state.campaigns.selectedCampaign)
      yield put(action.reviewMissionSuccess({
        answers: response.data.answers,
        mission_pages: response.data.mission_pages,
      }))
      yield put(push(route.mission_review_path(campaign, { id: payload.missionId })))
    }
  })
}


export default [watchForPreSelectMission, watchForAcceptMission,
  watchForMissionAnswered, watchForReviewMission]



// WEBPACK FOOTER //
// ./src/sagas/mission.jsx